import { render } from "./EditInventoryTransfer.vue?vue&type=template&id=44f9c8e6"
import script from "./EditInventoryTransfer.vue?vue&type=script&lang=js"
export * from "./EditInventoryTransfer.vue?vue&type=script&lang=js"

import "./EditInventoryTransfer.vue?vue&type=style&index=0&id=44f9c8e6&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__